import React from 'react';
import Image from 'next/image';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';
import { injectTestId } from '@cvent/nucleus-test-automation';

import cventLogo from '@images/cvent-logo.svg';

type LogoContainerProps = {
  testID: string;
};
export const LogoContainer = ({ testID }: LogoContainerProps): JSX.Element => {
  return (
    <Row role={'banner'} minHeight={'15vh'} justifyContent={'center'} testID={`${testID}_logo__row`}>
      <Col
        width={456}
        flex={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}
        padding={{ bottom: 32 }}
        testID={`${testID}_logo__col`}
      >
        <Image
          {...injectTestId(`${testID}_logo__img`)}
          alt="Cvent"
          src={cventLogo}
          layout={'fixed'}
          width={146}
          height={28}
        />
      </Col>
    </Row>
  );
};
